module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_c('b-button', {
    staticClass: "ml-auto btn-compact",
    attrs: {
      "disabled": _vm.item.ape_id !== '',
      "size": "sm",
      "variant": "outline-danger",
      "pill": ""
    },
    on: {
      "click": function($event) {
        _vm.$emit('remove', _vm.index)
      }
    }
  }, [_vm._v("\n      Remove\n      "), _c('i', {
    staticClass: "fa fa-minus",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), (_vm.isAdminRemovable && _vm.item.ape_id) ? _c('b-button', {
    staticClass: "ml-2 btn-compact",
    attrs: {
      "size": "sm",
      "variant": "outline-danger",
      "pill": ""
    },
    on: {
      "click": function($event) {
        _vm.$emit('remove-admin', _vm.item)
      }
    }
  }, [_vm._v("\n      Remove Admin\n      "), _c('i', {
    staticClass: "fa fa-minus",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e()], 1), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_vm._v(_vm._s(_vm.index + 1))]), _vm._v(" "), _c('td', [_c('model-list-select', {
    attrs: {
      "isDisabled": _vm.item.ape_id !== '',
      "list": _vm.ledgerData,
      "option-value": "ledgerId",
      "option-text": "ledger",
      "placeholder": "Select "
    },
    model: {
      value: (_vm.item.addTask_ledgerId),
      callback: function($$v) {
        _vm.$set(_vm.item, "addTask_ledgerId", $$v)
      },
      expression: "item.addTask_ledgerId"
    }
  }), _vm._v("\n    " + _vm._s(_vm.item.ape_transaction_no || '') + "\n    "), (_vm.item.addTask_ledgerId_err) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.item.addTask_ledgerId_err))]) : _vm._e()], 1), _vm._v(" "), _c('td', [_c('b-form-input', {
    attrs: {
      "disabled": _vm.item.ape_id !== '',
      "formatter": _vm.capitalizeAll,
      "type": "number",
      "step": "0.01",
      "inputmode": "decimal",
      "placeholder": "Enter amount"
    },
    on: {
      "wheel": _vm.handleWheel,
      "input": _vm.onNumberGuard,
      "change": _vm.onAmountChange,
      "blur": _vm.validateAmount
    },
    model: {
      value: (_vm.item.addTask_amount),
      callback: function($$v) {
        _vm.$set(_vm.item, "addTask_amount", $$v)
      },
      expression: "item.addTask_amount"
    }
  }), _vm._v(" "), (_vm.item.addTask_amount_err) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.item.addTask_amount_err))]) : _vm._e()], 1), _vm._v(" "), _c('td', [_c('model-list-select', {
    attrs: {
      "isDisabled": _vm.item.ape_id !== '',
      "list": _vm.currencies,
      "option-value": "currency_id",
      "option-text": "currencyCode",
      "placeholder": "Currency"
    },
    model: {
      value: (_vm.item.addTask_currency_id),
      callback: function($$v) {
        _vm.$set(_vm.item, "addTask_currency_id", $$v)
      },
      expression: "item.addTask_currency_id"
    }
  }), _vm._v(" "), (_vm.item.addTask_currency_id_err) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.item.addTask_currency_id_err))]) : _vm._e()], 1), _vm._v(" "), _c('td', [_c('b-form-radio-group', {
    staticClass: "mb-1",
    attrs: {
      "options": _vm.scCategoryList,
      "value-field": "SCVal",
      "text-field": "SCText",
      "buttons": "",
      "size": "sm",
      "button-variant": "outline-primary",
      "disabled": _vm.item.ape_id !== ''
    },
    on: {
      "input": _vm.onSCCategoryChange
    },
    model: {
      value: (_vm.item.addTask_scCategory),
      callback: function($$v) {
        _vm.$set(_vm.item, "addTask_scCategory", $$v)
      },
      expression: "item.addTask_scCategory"
    }
  }), _vm._v(" "), ((!_vm.item.addTask_scCategory) && _vm.item.addTask_scCategory_err) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.item.addTask_scCategory_err))]) : _vm._e()], 1), _vm._v(" "), _c('td', [(_vm.item.addTask_scCategory === 'Yes') ? _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "type": "number",
      "step": "0.01",
      "inputmode": "decimal",
      "disabled": _vm.item.ape_id !== '',
      "placeholder": "Selling amount"
    },
    on: {
      "wheel": _vm.handleWheel,
      "input": _vm.onNumberGuard,
      "change": _vm.onSellingAmountChange,
      "blur": _vm.validateSellingAmount
    },
    model: {
      value: (_vm.item.addTask_selling_amt),
      callback: function($$v) {
        _vm.$set(_vm.item, "addTask_selling_amt", $$v)
      },
      expression: "item.addTask_selling_amt"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.item.addTask_selling_amt_err) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.item.addTask_selling_amt_err))]) : (_vm.item.addTask_scCategory === 'No') ? _c('span', [_vm._v("No")]) : _vm._e()], 1), _vm._v(" "), _c('td', [(_vm.item.approval_status) ? _c('b-badge', {
    staticStyle: {
      "font-size": "0.75rem",
      "padding": "4px 8px"
    },
    attrs: {
      "variant": _vm.getApprovalStatusVariant(_vm.item.approval_status)
    }
  }, [_vm._v("\n      " + _vm._s(_vm.item.approval_status) + "\n    ")]) : _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("-")])], 1), _vm._v(" "), _c('td', [_c('b-form-textarea', {
    attrs: {
      "disabled": _vm.item.ape_id !== '',
      "formatter": _vm.capitalizeAll,
      "rows": "1",
      "max-rows": "3",
      "placeholder": "Remarks"
    },
    model: {
      value: (_vm.item.addTask_remark),
      callback: function($$v) {
        _vm.$set(_vm.item, "addTask_remark", $$v)
      },
      expression: "item.addTask_remark"
    }
  }), _vm._v(" "), (_vm.item.addTask_remark_err) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.item.addTask_remark_err))]) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8ba918f6","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/allModuleForm/components/AddTaskRow.vue
// module id = 2796
// module chunks = 0